import { DeleteIcon } from "components/common/Icons/DeleteIcon";
import { useDeleteIcon } from "../../../ControlBar/DeleteIcon/useDeleteIcon";

interface IconDeleteProps {
    close: () => void;
}

export const IconDelete = ({ close }: IconDeleteProps) => {
    const { handleDelete } = useDeleteIcon();
    function onClick() {
        handleDelete();
        close();
    }
    return (
        <div className="bg-white dark:bg-darkSurface-200 flex items-center justify-center pb-4">
            <button className="mx-auto px-4 py-2 rounded-md bg-red-500 inline-block" onClick={onClick}>
                <DeleteIcon />
            </button>
        </div>
    );
};
